import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'CountryLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CountryLookupUI/CountryLookupUI.vue'),
    },
    {
      name: 'CurrencyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CurrencyLookupUI/CurrencyLookupUI.vue'),
    },
    {
      name: 'MunicipalityLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MunicipalityLookupUI/MunicipalityLookupUI.vue'),
    },
    {
      name: 'ProvinceStateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProvinceStateLookupUI/ProvinceStateLookupUI.vue'),
    },
    {
      name: 'UnitTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnitTypeLookupUI/UnitTypeLookupUI.vue'),
    },
  ],
}
